import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { InquiriesRoutePath } from '../core/enums/route-types.enum';
import { UserPermissionsEnum } from '../core/enums/user-permissions.enum';
import { UserRole } from '../core/enums/user-role.enum';
import { ImpersonateService } from '../core/impersonate/impersonate.service';
import { PermissionsService } from '../core/services/permissions/permissions.service';
import { LogoComponent } from '../core/tree/logo/logo.component';
import { LanguageSwitchComponent } from '../shared/components/language-switch/language-switch.component';
import { SharedModule } from '../shared/shared.module';

@Component({
  selector: 'app-claims-unavailable',
  templateUrl: './claims-unavailable.component.html',
  styleUrls: ['./claims-unavailable.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, LanguageSwitchComponent, LogoComponent],
})
export class ClaimsUnavailableComponent implements OnInit {
  private authService = inject(AuthService);
  private impersonateService = inject(ImpersonateService);
  private permissionsService = inject(PermissionsService);
  private router = inject(Router);

  ngOnInit(): void {
    if (this.permissionsService.hasPermission(UserPermissionsEnum.VIEW_AND_CREATE_CLAIMS)) {
      this.router.navigate(['/', InquiriesRoutePath.ROOT, InquiriesRoutePath.CLAIMS]);
    }
  }

  onLogout(): void {
    // If the user is impersonating, unimpersonate first instead of logging out directly
    if (this.impersonateService.impersonated()) {
      this.impersonateService.unImpersonate();
      const user = this.authService.getUser();
      if (user?.role?.name === UserRole.ROLE_ADMIN && user?.redirect) {
        window.location.href = user.redirect;
      } else {
        this.authService.logout();
      }
    } else {
      this.authService.logout();
    }
  }
}
